export default __webpack_public_path__ + "static/media/Checkmark-circle.96e3d139.svg";